module.exports = __webpack_public_path__ + "static/media/facebook.c0d3ecf2.svg";